<ng-container *ngIf="tableData.grouped$">
  <table id="grouped" class="table table-sm" *ngIf="tableData.grouped$ | async as tableData">
    <thead>
      <tr>
        <th sortable="name" (sort)="onSort($event)" scope="col">{{'Description' | translate}}</th>
        <ng-container *ngFor="let name of tableData.columnNames; let i = index;">
          <th sortable [sortable]="'columns[' + i +'].value.numeric'" (sort)="onSort($event)" scope="col">{{ name }}</th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of tableData.rows">
        <tr *ngIf="row.isSubtitle; else notSubtitle">
          <th [colSpan]="tableData.columnNames.length + 1" scope="rowgroup" class="valmet-subtitle">{{ row.text }}</th>
        </tr>
        <ng-template #notSubtitle>
          <tr>
            <td>
              {{ row.name }}
            </td>
            <!-- Investigate: strictTemplates does not understand that column can be either empty or not -->
            <ng-container *ngFor="let column of row.columns">
              <ng-template #groupedHover>
                <ng-container *ngIf="column.tag; else tagNotFound">
                  <p>{{ column.tag.TagName}}</p>
                  <p>{{ column.tag.Description }}</p>
                </ng-container>

                <ng-template #tagNotFound>
                  <p>{{ 'Tag was not found' | translate }}: {{ column.requestedFullTag }}</p>
                </ng-template>

                <ng-container *ngIf="column.value">
                  <p>{{ column.value.ts }} ({{ timestampAgeInMinutes(column.value.ts) }} min)</p>
                </ng-container>
              </ng-template>
              <td
                *ngIf="!column.isEmpty"
                [class]="!column.value?.formatted ? 'text-warning': ''"
                [ngbTooltip]="groupedHover">
                {{ column.value?.formatted ? column.value.formatted : '-' }}
                <ng-container *ngIf="column.tag">
                  {{ column.tag.Unit }}
                </ng-container>
              </td>
              <td
                *ngIf="column.isEmpty"
                class="text-warning"
                ngbTooltip="{{ 'Tag not configured' | translate}}">
                -
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </ng-container>
    </tbody>
  </table>
</ng-container>


<ng-container *ngIf="tableData.ungrouped$">
  <table id="ungrouped" class="table table-sm" *ngIf="tableData.ungrouped$ | async as tableData">
    <thead>
      <tr>
        <th sortable="description" (sort)="onSort($event)" scope="col">{{'Description' | translate}}</th>
        <th sortable="value.numeric" (sort)="onSort($event)" scope="col">
          {{'Value' | translate}}
        </th>
        <th scope="col">{{'Timestamp' | translate}}</th>
      </tr>
    </thead>
    <tbody>


      <ng-container *ngFor="let row of tableData.rows">
        <tr *ngIf="row.isSubtitle; else notSubtitle">
          <th colspan="3" scope="rowgroup" class="valmet-subtitle">{{ row.text }}</th>
        </tr>
        <ng-template #notSubtitle>
          <ng-container *ngIf="row.tag; else tagNotFoundBlock">
            <tr [class]="row.value?.numeric === 0 ? 'inactive': ''">
              <td [ngbTooltip]="row.tag.TagName">
                {{ row.tag.Description }}
              </td>
              <td [class]="!row.value?.formatted ? 'text-warning': ''">
                {{ row.value && row.value.numeric !== 0 ? row.value.formatted : '-' }}
                {{ row.tag.Unit }}
              </td>
              <ng-container *ngIf="row.value?.ts; else timestampNotFound">
                <td [ngbTooltip]="row.value.ts">
                  {{ timestampAgeInMinutes(row.value.ts) }} min
                </td>
              </ng-container>
              <ng-template #timestampNotFound>
                <td></td>
              </ng-template>
            </tr>
          </ng-container>
        </ng-template>

        <ng-template #tagNotFoundBlock>
          <tr>
            <td class="tag-not-found" [ngbTooltip]="row.requestedFullTag">
              {{ 'Tag was not found' | translate }}
            </td>
            <td>
              -
            </td>
            <td>
              -
            </td>
          </tr>
        </ng-template>

      </ng-container>

      <ng-container *ngIf="tableData.totalValueSum">
        <tr>
          <td>
            {{ 'Total' | translate }}
          </td>
          <td>
            ~ {{ tableData.totalValueSum }}
          </td>
          <td></td>
        </tr>
      </ng-container>

    </tbody>
  </table>
</ng-container>

<ng-container *qmLoading="loading;config:loadingConfig"></ng-container>
